import React from 'react';
import Header from './Header';
import Sidebar from './Sidebar';

const Layout = ({ children }) => {
  return (
    <div className="min-h-screen bg-gray-900">
      <Header />
      <Sidebar />
      <main className="ml-0 md:ml-60 mt-14 sm:mt-16 p-4 sm:p-6">
        {children}
      </main>
    </div>
  );
};

export default Layout;
